/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
/*모든 페이지의 레이아웃을  정의한다
헤더 컨텐츠 푸터 모두 여기에 넣기*/
import React from "react"
import PropTypes from "prop-types"
//import { useStaticQuery, graphql } from "gatsby"

import Header from "./layout/HeaderEn"
import Footer from "./layout/FooterEn"
import LeftLine from "./layout/leftLine"

const Layout = ({ children }) => {
  /*const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)*/

  return (
    <>
      <Header />
      <LeftLine />
      <div>
        {/*컨텐츠*/}
        <main>{children}</main>
      </div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
